import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_ORDER_RESULT_STORE_NAME, GetOrderResultState } from './get-order-result.state';

/** Select GetOrderResult State */
export const selectGetOrderResultState = createFeatureSelector<GetOrderResultState>(GET_ORDER_RESULT_STORE_NAME);

/** Select GetOrderResult isPending status */
export const selectGetOrderResultIsPendingStatus = createSelector(
  selectGetOrderResultState,
  (state) => !!state.isPending
);

/** Select GetOrderResult isFailure status */
export const selectGetOrderResultIsFailureStatus = createSelector(
  selectGetOrderResultState,
  (state) => !!state.isFailure
);
